import $ from 'jquery';
import Cookies from 'js-cookie';

$(function () {
    if ($('.alert').length !== 0) {
        $('.alert-close').on('click', function () {
            $('.alert').addClass('d-none');
            Cookies.set('rwd_alert_closed', true);
        });
    }
});
